import i18n from "i18next";
import XHR from 'i18next-xhr-backend';
//import LanguageDetector from "i18next-browser-languagedetector";

//SbC baseline translations bundled in the build so page titles render on first
//paint without waiting for the API. The remote backend still overrides this with
//the live copy; keep this file in sync on deploy (source of truth = translation.php).
import translationNL from './locales/translation-NL.json';

const urlAPI = process.env.REACT_APP_URL_API;

const backendOpts = {
    loadPath: urlAPI + `/translation/translation.php?lang={{lng}}`,
    crossDomain: true,
    allowMultiLoading: true
}

i18n
    //.use(LanguageDetector)
    .use(XHR)
    .init({
        lng: "nl",
        preload: ['nl'],
        load: 'languageOnly',
        backend: backendOpts,

        //SbC bundled resources render immediately; partialBundledLanguages keeps the
        //backend fetch alive so the live translations still override the baseline.
        resources: {
            nl: {
                translation: translationNL
            }
        },
        partialBundledLanguages: true,

        fallbackLng: "nl",
        //debug: process.env.NODE_ENV === "development",
        defaultNS: "translation",
       
        order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        caches: ['localStorage', 'cookie'],

        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },

        react: {
            useSuspense: true
        }
    });

export default i18n;